export default __webpack_public_path__ + "static/media/icon-github.16a984f7.svg";